import React from 'react'
import { MdStar } from 'react-icons/md'

import { Box, Flex, Heading, Text } from '../system'
import ImagePlaceholder from '../placeholder'

const Card = () => (
  <Box width="20rem">
    <ImagePlaceholder borderRadius={1} boxShadow={0} mb={2} />
    <Flex>
      <Text
        color="grey.600"
        fontFamily="brand"
        fontSize={1}
        letterSpacing="tracked"
        css={{
          textTransform: 'uppercase',
        }}
      >
        greglobinski/
      </Text>
      <Flex alignItems="center" color="grey.600" fontSize={1} ml="auto">
        <MdStar /> 167
      </Flex>
    </Flex>
    <Heading as="h3" fontSize={4} fontWeight={1}>
      gatsby-starter-personal-blog
    </Heading>
    <Text fontSize={1}>A Gatsby starter for a personal blog</Text>
    <Flex mt={4}>
      <Text color="grey.500" fontSize={0}>
        Updated 3 days ago
      </Text>
      <Box />
    </Flex>
  </Box>
)

export default Card
